import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { form1Submitted, sendFooterContact } from '../../actions/forms';
import {
    consumeCaptchaToken, isCaptchaError, normalizeEmail, requireCaptchaAfterAttempt
} from '../../helpers/security';
import PublicFormProtection from '../Security/PublicFormProtection';

//MUI
import {
    FormControl, Grid, TextField, MenuItem, FormHelperText, Button
} from '@mui/material'
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core/styles";
import EastIcon from '@mui/icons-material/East';

import { regex_email, regex_no_num, regex_num } from '../../constants/regex';

const ColorButton = styled(Button)(({ theme }) => ({
    color: '#38B6FF',
    backgroundColor: '#fff',
    paddingLeft: '40px',
    paddingRight: '40px',
    textTransform: 'none',
    fontWeight: 'bold',
    transition: 'all ease-in-out 0.4s',
    '&:hover': {
        backgroundColor: '#000',
        color: '#fff'
    }
}));

const init = {
    name: '',
    email: '',
    phone: '',
    subject: '',
    msg: '',
    website: ''
};

const initErr = {
    name_err: false,
    email_err: false,
    phone_err: false,
    subject_err: false,
    msg_err: false
};

const subjectTypeSelect = ['Información de productos', 'Queja o sugerencia', 'Otro'];

const useStyles = makeStyles({
    root: {
        "& .MuiOutlinedInput-root": {
            background: "rgb(232, 241, 250)"
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            display: 'none'
        },
        // "& .MuiInputLabel-root": {
        //     color: "#56C596"
        // },
        // "&:hover .MuiOutlinedInput-input": {
        //     color: "#5552B2"
        // },
        // "&:hover .MuiInputLabel-root": {
        //     color: "#3c9570"
        // },
        // "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        //     borderColor: "#3c9570"
        // },
        // "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
        //     color: "#5552B2"
        // },
        // "& .MuiInputLabel-root.Mui-focused": {
        //     color: "#56C596"
        // },
        // "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        //     borderColor: "#56C596"
        // },
        // '& .MuiSvgIcon-root': {
        //     color: '#56C596',
        // }
    }
});

const ContactForm = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { form1 } = useSelector(state => state.form);

    const [values, setValues] = useState(init);
    const { name, email, phone, subject, msg, website } = values;
    const [security, setSecurity] = useState({ required: false, token: '', key: 0 });

    const [inputErr, setInputErr] = useState(initErr);
    const { name_err, email_err, phone_err, subject_err, msg_err } = inputErr;

    const name_ref = useRef();
    const email_ref = useRef();
    const phone_ref = useRef();
    const msg_ref = useRef();

    useEffect(() => {
        if (form1) {
            setValues(init);
            setSecurity({ required: false, token: '', key: 0 });
            dispatch(form1Submitted(false));
        }
    }, [form1]);

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'name') {
            if (value === '' || regex_no_num.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                }));
            }
        } else if (name === 'phone') {
            if (value === '' || regex_num.test(value)) {
                setValues(e => ({
                    ...e,
                    [name]: value
                }));
            }
        } else setValues(e => ({
            ...e,
            [name]: value
        }));
        switch (name) {
            case 'name':
                setInputErr({
                    ...inputErr,
                    name_err: (value.length < 2 ||
                        value.length > 50) ? true : false
                });
                break;
            case 'email':
                setInputErr({
                    ...inputErr,
                    email_err: (value.length < 6 ||
                        value.length > 120) ? true : false
                });
                break;
            case 'phone':
                setInputErr({
                    ...inputErr,
                    phone_err: (value.length < 3 ||
                        value.length > 20) ? true : false
                });
                break;
            case 'subject':
                setInputErr({
                    ...inputErr,
                    subject_err: (value.length < 1) ? true : false,
                });
                break;
            case 'msg':
                setInputErr({
                    ...inputErr,
                    msg_err: (value.length < 6 ||
                        value.length > 1000) ? true : false
                });
                break;
            default:
                break;
        }
    };

    const formValidator = () => {
        const name_len = name.trim().length;
        if (name_len > 1 && name_len <= 50) {
            const email_len = email.trim().length;
            if (email_len > 5 && email_len <= 120 && regex_email.test(email)) {
                const phone_len = phone.trim().length;
                if (phone_len > 2 && phone_len <= 20) {
                    const subject_len = subject.trim().length
                    if (subject_len > 0) {
                        const msg_len = msg.trim().length
                        if (msg_len > 5 && msg_len <= 1000) {
                            return true
                        } else {
                            msg_ref.current.select();
                            setInputErr({
                                ...inputErr,
                                msg_err: true
                            });
                        }
                    } else {
                        setInputErr({
                            ...inputErr,
                            subject_err: true
                        });
                    }
                } else {
                    phone_ref.current.select();
                    setInputErr({
                        ...inputErr,
                        phone_err: true
                    });
                }
            } else {
                email_ref.current.select();
                setInputErr({
                    ...inputErr,
                    email_err: true
                });
            }
        } else {
            name_ref.current.select();
            setInputErr({
                ...inputErr,
                name_err: true
            });
        }
        return false;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formValidator()) {
            const token = security.token;
            if (token) setSecurity(current => consumeCaptchaToken(current, token));
            const body = await dispatch(sendFooterContact({
                ...values,
                email: normalizeEmail(email)
            }, token));
            if (isCaptchaError(body)) setSecurity(current =>
                requireCaptchaAfterAttempt(current, token));
        }
    };

    return (

        <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        InputLabelProps={{ shrink: false }}
                        placeholder='Nombre'
                        size='small'
                        name='name'
                        error={name_err}
                        helperText={name_err ? "Ingrese su nombre" : ""}
                        inputRef={name_ref}
                        value={name}
                        onChange={handleInputChange}
                        inputProps={{ maxLength: 50 }}
                        InputProps={{ sx: { borderRadius: '15px' } }}
                    />
                </FormControl>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        InputLabelProps={{ shrink: false }}
                        placeholder='Correo electrónico'
                        size='small'
                        name='email'
                        error={email_err}
                        helperText={email_err ? "Ingrese su correo electrónico" : ""}
                        inputRef={email_ref}
                        value={email}
                        onChange={handleInputChange}
                        inputProps={{ maxLength: 120 }}
                        onBlur={() => setValues(current => ({
                            ...current,
                            email: normalizeEmail(current.email)
                        }))}
                        InputProps={{ sx: { borderRadius: '15px' } }}
                    />
                </FormControl>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        InputLabelProps={{ shrink: false }}
                        placeholder='Teléfono'
                        size='small'
                        name='phone'
                        error={phone_err}
                        helperText={phone_err ? "Ingrese su número de teléfono" : ""}
                        inputRef={phone_ref}
                        value={phone}
                        onChange={handleInputChange}
                        inputProps={{ maxLength: 20 }}
                        InputProps={{ sx: { borderRadius: '15px' } }}
                    />
                </FormControl>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        InputLabelProps={{ shrink: false }}
                        placeholder='Asunto'
                        size='small'
                        name="subject"
                        error={subject_err}
                        value={subject}
                        onChange={handleInputChange}
                        select
                        InputProps={{ sx: { borderRadius: '15px', textAlign: 'left' } }}
                        sx={{
                            '& .MuiSelect-select span::before': {
                                content: "'Asunto'",
                                color: '#93999F'
                            },
                        }}
                    >
                        {subjectTypeSelect.map((e, i) => (
                            <MenuItem key={i}
                                value={e}>
                                {e}
                            </MenuItem>
                        ))}
                    </TextField>
                    {
                        subject_err &&
                        <FormHelperText
                            error={subject_err}>
                            Escoja el asunto del mensaje
                        </FormHelperText>
                    }
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <FormControl fullWidth>
                    <TextField
                        className={classes.root}
                        InputLabelProps={{ shrink: false }}
                        placeholder='Mensaje'
                        size='small'
                        name='msg'
                        error={msg_err}
                        helperText={msg_err ? "Escriba su mensaje" : ""}
                        inputRef={msg_ref}
                        value={msg}
                        onChange={handleInputChange}
                        inputProps={{ maxLength: 1000 }}
                        multiline
                        rows={6}
                        InputProps={{
                            sx: { borderRadius: '15px' },
                            // endAdornment: (
                            //     <IconButton>
                            //         <EastIcon />
                            //     </IconButton>
                            // )
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{ mx: 'auto', textAlign: 'center' }}>
                <PublicFormProtection
                    website={website}
                    onWebsiteChange={handleInputChange}
                    captchaRequired={security.required}
                    captchaKey={security.key}
                    action="footer_contact"
                    onVerify={token => setSecurity(current => ({ ...current, token }))}
                />
                {/* <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}></Stack> */}
                <ColorButton variant='contained' onClick={handleSubmit} endIcon={<EastIcon />}>Enviar</ColorButton>
            </Grid>
        </Grid>
    );
};

export default ContactForm;
